import { render, staticRenderFns } from "./MyWeibo.vue?vue&type=template&id=ca09f83c&"
import script from "./MyWeibo.vue?vue&type=script&lang=js&"
export * from "./MyWeibo.vue?vue&type=script&lang=js&"
import style0 from "./MyWeibo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports